import { RefObject, useState } from "react";
import { ReactComponent as DownloadIcon } from "assets/download.svg";
import { Button } from "components";
import { useModifiedTranslation } from "hooks/useModifiedTranslation";
import { toast } from "react-toastify";
import { exportElementToPdf } from "services/pdfExport";
import { captureException } from "services/sentry";

interface PdfDownloadButtonProps {
  targetRef: RefObject<HTMLElement>;
  filename: string;
  title: string;
  subtitle?: string;
  contactName?: string;
}

export const PdfDownloadButton = ({
  targetRef,
  filename,
  title,
  subtitle,
  contactName,
}: PdfDownloadButtonProps) => {
  const { t, i18n } = useModifiedTranslation();
  const [loading, setLoading] = useState(false);

  const onClick = async () => {
    const element = targetRef.current;
    if (!element) return;
    setLoading(true);
    try {
      await exportElementToPdf({
        element,
        filename,
        title,
        subtitle,
        contactName,
        asOfDate: new Date(),
        locale: i18n.language,
      });
    } catch (err) {
      captureException(err);
      toast.error(t("pdfExport.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-pdf-ignore>
      <Button
        variant="Secondary"
        size="xs"
        LeftIcon={DownloadIcon}
        isLoading={loading}
        onClick={onClick}
      >
        {t("pdfExport.button")}
      </Button>
    </div>
  );
};
